import { Box, Paper, PaperProps, Table, TableBody, TableCell, TableHead, TablePagination, TableRow, Typography } from '@material-ui/core';
import { makeStyles, Theme } from '@material-ui/core/styles';
import { isEmpty } from 'lodash';
import moment from 'moment-timezone';
import React from 'react';
import TableSkeleton from '../../components/TableSkeleton';
import { usePennameStories } from '../../hooks/queries/usePenname';
import useTablePagination from '../../hooks/useTablePagination';
import settings from '../../services/settings';

interface IProps {
  pennameId: number;
}

const useStyles = makeStyles((theme: Theme) => ({
  idTableCell: {
    width: 80,
  },
  createdAtTableCell: {
    width: 240,
  },
  tableRow: {
    height: 52,
  },
}));

const PennameStoryList = (props: IProps & PaperProps): JSX.Element => {
  const classes = useStyles();
  const { pennameId, ...restProps } = props;

  const { page, setPage, rowsPerPage, setRowsPerPage } = useTablePagination();

  const { data: storiesFromQuery, isLoading } = usePennameStories(pennameId, page, rowsPerPage);

  const stories = storiesFromQuery?.items;
  const totalCount = storiesFromQuery?.totalCount;

  return (
    <Paper {...restProps}>
      <Table>
        <TableHead>
          <TableCell align="center" padding="none" className={classes.idTableCell}>
            Story ID
          </TableCell>
          <TableCell>Story Title</TableCell>
          <TableCell>Season</TableCell>
          <TableCell className={classes.createdAtTableCell}>Created At</TableCell>
        </TableHead>
        <TableBody>
          {isLoading && <TableSkeleton rows={3} columns={4} />}
          {!isLoading &&
            stories &&
            stories.map(story => {
              const { id, title, seasonCount, createdAt } = story;
              return (
                <TableRow key={id} component={'a'} target="_blank" href={`${settings.getCrewURI()}/stories/${id}`} hover className={classes.tableRow}>
                  <TableCell align="center" padding="none">
                    {id}
                  </TableCell>
                  <TableCell>{title}</TableCell>
                  <TableCell>{seasonCount}</TableCell>
                  <TableCell>{moment(createdAt).format('LLL')}</TableCell>
                </TableRow>
              );
            })}
        </TableBody>
      </Table>
      {!isLoading && isEmpty(stories) && (
        <Box width="100%" height="156px" display="flex" alignItems="center" justifyContent="center">
          <Typography variant="body1">There are no items to show.</Typography>
        </Box>
      )}
      <TablePagination
        count={totalCount || -1} // an unknown number of items, provide -1. (https://material-ui.com/api/table-pagination/)
        rowsPerPage={rowsPerPage}
        page={page - 1} // TablePagination has the zero-based index of the current page.
        onChangePage={(_: unknown, p: number) => setPage(p + 1)}
        onChangeRowsPerPage={(e: React.ChangeEvent<HTMLInputElement>) => {
          const rpp = parseInt(e.target.value, 10);
          setRowsPerPage(rpp);
          setPage(1);
        }}
      />
    </Paper>
  );
};

export default PennameStoryList;
